import { University } from "lucide-react";

export const conferenceInfo = {
  title: "INTERNATIONAL CONFERENCE",
  subtitle:
    "TRANSPORTATION GEOTECHNICS & SUSTAINABLE MATERIALS FOR ADVANCED RESILIENT INFRASTRUCTURE",
  shortName: "(TG-SMART 2026)",
  dates: "OCTOBER 8-10, 2026",
  venue: "Integral University, Lucknow",
};

// CONVENOR AND CO-CONVENORS
export const convenor = {
  name: "Prof. Syed Aqeel Ahmad",
  linkedin:
    "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-CV%20_Dr.%20Syed%20Aqeel%20Ahmad.pdf",
  designation: "Professor & Head, Department of Civil Engineering",
  organization: "Integral University, Lucknow",
  message:
    "As Convener of TG-SMART 2026, it is my privilege to present this international conference as a significant academic and professional forum in the field of transportation geotechnics and sustainable infrastructure. The conference is envisioned to bring together researchers, academicians, industry experts, and policymakers to deliberate on emerging challenges and innovative solutions related to ground improvement, geosynthetics, pavement and subsurface geotechnics, geo-hazards, earthquake geotechnics, and climate-resilient infrastructure. TG-SMART 2026 emphasizes research-driven, sustainable, and field-implementable solutions that address the evolving needs of modern infrastructure development. Through technical sessions, keynote lectures, and industry interactions, the conference aims to foster meaningful knowledge exchange and strengthen collaboration between academia and industry. I warmly invite participants to contribute their research and be part of this collective effort toward building resilient and sustainable infrastructure systems. TG-SMART 2026 provides a high-impact platform for industry leaders to showcase innovative technologies, discuss real-world infrastructure challenges, and collaborate with leading academicians and researchers.",
  image: "/images/convenors/convenor.jpg",
};

export const coConvenors = [
  {
    id: 1,
    name: "Dr. A. P. Singh",
    linkedin: "https://linkedin.com/in/dr-a-p-singh-2525b61a",
    designation: "Honorary Secretary",
    organization: "Indian Geotechnical Society, India",
    phone: "",
    email: "",
    message:
      "TG-SMART 2026 serves as a focused platform for academicians, researchers, and industry professionals to exchange ideas on transportation geotechnics and sustainable materials for resilient infrastructure. The conference emphasizes ground improvement, geosynthetics, pavement and subsurface geotechnics, geo-hazards, earthquake geotechnics, and climate-resilient infrastructure. With a strong orientation toward practical, research-driven, and sustainable solutions, TG-SMART 2026 aims to strengthen academia–industry collaboration and contribute meaningfully to the advancement of modern infrastructure engineering.",
    image: "/images/convenors/co-convenor1.jpg",
  },
  {
    id: 2,
    name: "Dr. Zishan Raza Khan",
    linkedin: "https://www.iul.ac.in/ccgnd/Default.aspx",
    designation: "Associate Professor, Department of Civil Engineering",
    organization: "Integral University, Lucknow",
    phone: "",
    email: "",
    message:
      "TG-SMART 2026 emphasizes research-driven, practical, and field-implementable solutions aligned with national and global infrastructure needs. Through keynote lectures, technical sessions, poster presentations, and industry interactions, the conference seeks to foster meaningful knowledge exchange and strengthen academia–industry collaboration. We warmly invite researchers and professionals to contribute and be part of this intellectually stimulating event.",
    image: "/images/convenors/co-convenor2.jpg",
  },
  {
    id: 3,
    name: "Dr. Yusuf Jamal",
    linkedin: "https://www.linkedin.com/in/yusuf-jamal-9142a8101/",
    designation: "Associate Professor, Department of Civil Engineering",
    organization: "Integral University, Lucknow",
    phone: "",
    email: "",
    message:
      "TG-SMART 2026 places strong emphasis on sustainable construction practices, waste-to-resource materials, advanced testing and monitoring techniques, and data-driven geotechnical solutions with real-world applicability. By fostering interdisciplinary dialogue and industry–academia collaboration, the conference aims to promote research that is both scientifically rigorous and practically implementable. We look forward to welcoming contributors whose work supports resilient, sustainable, and future-ready infrastructure development.",
    image: "/images/convenors/co-convenor3.jpg",
  },
];

// NOTICES WITH PDF LINKS
export const notices = [
  {
    id: 1,
    date: "13-04-2026",
    text: "TGSMART Brochure, (Abstract Extended)",
    pdfUrl: "/pdfs/notices/notice1.pdf",
  },
  {
    id: 2,
    date: "20-04-2026",
    text: "Abstract Template",
    pdfUrl: "/pdfs/notices/notice2.pdf",
  },
  {
    id: 3,
    date: "27-06-2026",
    text: "Full length paper format",
    pdfUrl: "/pdfs/notices/notice3.pdf",
  },
  {
    id: 4,
    date: "28-09-2026",
    text: "Latest Update",
    pdfUrl: "/pdfs/notices/notice4.pdf",
  },
];

// CAROUSEL IMAGES
export const bannerImages = ["/images/banner/slide1.jpg"];

// CAROUSEL IMAGES
export const carouselImages = [
  "/images/carousel/slide1.jpg",
  "/images/carousel/slide2.jpg",
  "/images/carousel/slide3.jpg",
  "/images/carousel/slide4.jpg",
  "/images/carousel/slide5.jpg",
  "/images/carousel/slide6.jpg",
  "/images/carousel/slide7.jpg",
  "/images/carousel/slide8.jpg",
];

export const LINKS = {
  ABOUT_CONFERENCE: "https://tgsmart2026.iul.ac.in/",
  INTEGRAL_UNIVERSITY: "https://iul.ac.in/",
  LUCKNOW_CHAPTER: "https://www.igs.org.in/local-chapter/lucknow",
  CSIR_CBRI: "https://cbri.res.in/",
  CSIR_CRRI: "- https://crridom.gov.in/en",
  CIVIL_DEPT: "https://www.iul.ac.in/CE/Faculty.aspx",
};

// DIGNITARIES
export const chiefPatron = {
  name: "Prof. Syed Waseem Akhtar",
  linkedin: "https://www.iul.ac.in/About/leadership/Chancellor.aspx",
  designation: "Hon'ble Chancellor & Founder",
  organization: "Integral University, Lucknow",
  image: "/images/dignitaries/chiefpatron/chief-patron.jpg",
};

export const patrons = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: ` ${["Dr. Syed Nadeem Akhtar", "Mr. Syed M. Fauzan Akhtar", "Mr. Syed Adnan Akhtar", "Dr.  Nida Fatima"][i]} `,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/About/leadership/ProChancellor.aspx",
      "https://www.iul.ac.in/About/leadership/Additional-Pro-Chancellor%E2%80%93IIMSR.aspx",
      "https://www.iul.ac.in/About/leadership/Additional-Pro-Chancellor%E2%80%93IIPSR.aspx",
      "https://www.iul.ac.in/About/leadership/Additional-Pro-Chancellor%E2%80%93ISF-CIED.aspx",
    ][i]
  } `,
  designation: ` ${["Hon'ble Pro Chancellor", "Hon'ble Additional Pro Chancellor", "Hon'ble Additional Pro Chancellor", "Hon'ble Additional Pro Chancellor"][i]} `,
  organization: "Integral University",
  image: `/images/dignitaries/patrons/patron${i + 1}.jpg`,
}));

export const conferenceChair = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: ` ${["Prof. Furqan Qamar", "Prof. Pradeep Kr. Ramancharla", "Prof. Chalumuri Ravi Sekhar", "Dr. Anil Joseph"][i]} `,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/About/leadership/ViceChancellor.aspx",
      "https://cbri.res.in/prof-ramancharla-pradeep-kumar",
      "https://crridom.gov.in/en/director-crri",
      "https://www.igs.org.in/members/dr-anil-joseph1",
    ][i]
  } `,
  designation: ` ${["Hon'ble Vice Chancellor", "Director", "Director", "President"][i]} `,
  organization: ` ${["Integral University", "CSIR-CBRI, Roorkee", "CSIR-CRRI, New Delhi", "Indian Geotechnical Society"][i]} `,
  image: `/images/dignitaries/conchair/chair${i + 1}.jpg`,
}));

export const coPatrons = Array.from({ length: 26 }, (_, i) => ({
  id: i + 1,
  name: ` ${["Prof. Mohammad Haris Siddiqui", "Prof. Abdul Rahman Khan", "Prof. Sunil Kumar", "Prof. Wahajul Haq", "Dr. Mohd Atif Siddiqui", "Prof. Mohammad Faisal", "Prof. Alvina Farooqui", "Prof. Saba Siddiqui", "Dr. Mohammad Sufian Abbasi", "Dr. Syed Belal Hassan", "Dr. Tariq Mahmood", "Mr. Parvez Ahmad Khan", "Mr. Ahmad Raza", "Shri Ashok Kumar Dwivedi", "Shri Mukesh Chand Sharma", "Shri Vijai Kanaujia", "Sri. Devendra Singh", "Sri. D D Pathak", "Shri Ram Nath Singh", "Shri Dharm Veer Singh", "Shri Ramesh Chandra (IAS)", "Shri Sandeep Kumar", "Shri Ashok Kumar Singh", "Mr. Vinod Kr Srivastava", "Er. Ashish Yadav", "Mr. Brijesh Dubey"][i]}`,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/About/leadership/Registrar.aspx",
      "https://www.iul.ac.in/About/leadership/ControllerExaminations.aspx",
      "https://www.iul.ac.in/Engineering",
      "https://linkedin.com/in/wahajul-haq-a73ba2215",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Electrical%20Engineering/_Electrical%20Engineering-CV_Dr.%20M%20A%20Siddiqui_EED.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Computer%20Application/_Computer%20Application-Dr%20Mohammad%20Faisal_ShortCV.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Bioengineering/_Bioengineering-CV_For_Deptt_Website_Template-1.pdf",
      "https://iiast.iul.ac.in/Faculty-Details.aspx?FId=454",
      "https://www.linkedin.com/in/er-mohd-sufian-abbasi-7b4576252",
      "https://www.linkedin.com/in/syed-hassan-54285515",
      "",
      "",
      "",
      "https://uppwd.gov.in/en/deptofficer",
      "https://uppwd.gov.in/en/deptofficer",
      "https://uppwd.gov.in/en/deptofficer",
      "",
      "https://www.linkedin.com/in/er-d-d-pathak-85492b294",
      "https://www.uprnn.upsdc.gov.in/en/page/technical-team",
      "https://www.linkedin.com/in/dharm-veer-singh-487537309",
      "http://www.cst.up.gov.in",
      "https://dmpidup.com",
      "https://dmpidup.com",
      "https://www.linkedin.com/in/ashok-kumar-singh-b1990647",
      "https://www.linkedin.com/in/ashish-yadav-b3341240",
      "https://www.linkedin.com/in/brijesh-dubey-704858a9",
    ][i]
  } `,
  designation: ` ${["Registrar", "Controller of Examination", "Dean, Engineering & IT", "Dean, R&D", "Addl. Director(Admission & Academics) & Head, Dept. of Electrical Engineering", "Provost & Head, Dept. of Computer Application", "Convenor Academic Program & Research Committee & Head, Dept. Of Bioengineering", "Head, Dept. of Agriculture", "Director,Procurement", "Director, IIMSR", "Professor & Head", "Professor of Practice", "Treasurer", "Engineer in Chief (Development) & Head", "Engineer in Chief (Rural Roads)", "Engineer in Chief (Design & Planning)", "State Quality Coordinator (SQC)/Dy. CEO", "State Technical Officer (STO)", "MD", "MD", "Director", "Engineer in Chief & Head", "Engineer in Chief (D&P)", "President", "National Secretary General & General Secretary", "Senior Engineer/Chief Engineer"][i]}`,
  organization: ` ${["Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "UPPWD", "UPPWD", "UPPWD", "PMGSY", "PMGSY", "UP Rajkiya Nirman Nigam, Lucknow", "UP State Bridge Corporation Ltd, Lucknow", "CST, U.P.", "Irrigation & Water Resource Dept, Lucknow", "Irrigation & Water Resource Dept, Lucknow", "UP Engineers Association", "Indian Engineers Federation(INDEF) & UP Engineers Association", "UPRRDA, Lucknow"][i]} `,
  image: `/images/dignitaries/copatrons/co-patron${i + 1}.jpg`,
}));

// COMMITTEE MEMBERS
export const organizingCommittee = Array.from({ length: 6 }, (_, i) => ({
  id: i + 1,
  name: `${["Dr. Manojit Samanta", "Dr. Ravi Shankar S.", "Dr. Vikash Singh", "Dr. Vinay Bhushan Chauhan", "Dr. Sarfaraz Ahmed", "Dr. Utkarsh Mishra"][i]}`,
  linkedin: ` ${
    [
      "https://www.linkedin.com/in/manojit-samanta-6288b554",
      "https://www.linkedin.com/in/dr-ravi-shankar-s-038827163",
      "linkedin.com/in/vikash-singh-6292b3334",
      "https://sites.google.com/view/vbciitb/education",
      "https://www.linkedin.com/in/sarfaraz-ahmed-ph-d-463350a4",
    ][i]
  } `,
  designation: ` ${["Senior Principal Scientist", "Senior Scientist", "Assistant Professor and Treasurer", "Assistant Professor", "Senior Scientist", "Assistant Professor"][i]}`,
  organization: `${["CSIR CBRI, Roorkee", "CSIR CRRI, New Delhi", "CED, IET and IGS Lucknow Chapter ", "CED, MMMUT Gorakhpur and Honorary Secretary IGS Lucknow Chapter", "CSIR CRRI, New Delhi", "Integral University"][i]}`,
  image: `/images/committee/organizing/member${i + 1}.jpg`,
}));
export const jointorganizingCommittee = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Dr. K. Venkatesh",
      "Dr. Aayush Kumar",
      "Mr. Shamim Ahmad",
      "Mr. Harshit Srivastava",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://mnnit.ac.in/profile/venkatesh",
      "https://sites.google.com/view/info-aayush/home",
      "https://www.linkedin.com/in/shameem-ahmad-1533005b",
      "https://www.linkedin.com/posts/harshit-kumar-srivastava-826540168",
    ][i]
  } `,
  designation: ` ${["Professor", "Assistant Professor", "Field Director", "Technical Director"][i]}`,
  organization: `${["CED, MNNIT Allahabad", "CED, KMC Language University, Lucknow", "Arun Soil Lab Pvt. Ltd., Lucknow", "Arun Soil Lab Pvt. Ltd., Lucknow"][i % 4]}`,
  image: `/images/committee/jointorganizing/member${i + 1}.jpg`,
}));

export const advisoryCommittee = Array.from({ length: 36 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Dr. Brij Kishor Pandey",
      "Dr. Lindung Zalbuin Mase",
      "Dr. Saif Alzabeebee",
      "Dr. Krishna R. Reddy",
      "Dr. Prabir K Kolay",
      "Dr. Sanjay Nimbalkar",
      "Dr. Adewole Oladele",
      "Dr. Tatsuya Ishikawa",
      "Dr. S.K. Shukla",
      "Dr. T.G. Sitharam",
      "Dr. A. Murali Krishna",
      "Dr. Amarnath Hegde",
      "Dr. Arindam Dey",
      "Dr. C.R. Parthasarathy",
      "Dr. Kala Venkata Uday",
      "Dr. Madhavi Latha Gali",
      "Dr. Mahendra Singh",
      "Dr. Sunita Kumari",
      "Dr. Ankit Gupta",
      "Dr. B.A. Mir",
      "Dr. B. Munwar Basha",
      "Dr. Brind Kumar",
      "Dr. Deepankar Choudhury",
      "Dr. Dharamveer Singh",
      "Prof. G.L. Sivakumar Babu",
      "Dr. Jagdish Prasad Sahoo",
      "Dr. M.R. Madhav",
      "Dr. N.K. Samadhiya",
      "Dr. Neelima Satyam",
      "Dr. P.K. Agarwal",
      "Dr. Anbazhagan P",
      "Dr. Ravi Sundaram",
      "Dr. Shoeb Malik",
      "Dr. V.B. Maji",
      "Dr. T.N. Singh",
      "Mr. Niranjan Singh",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.bits-pilani.ac.in/dubai/brij-kishor-pandey/",
      "https://engineering.unib.ac.id/bce/lecturers/",
      "https://www.linkedin.com/in/saif-alzabeebee-phd-b4153358",
      "https://cme.uic.edu/profiles/krishna/",
      "https://faculty.siu.edu/profiles/j-l/kolay-prabir.php",
      "https://profiles.uts.edu.au/Sanjay.Nimbalkar",
      "https://www.nust.na/prof-adewole-simon-oladele",
      "https://www.eng.hokudai.ac.jp/labo/geomech/english/member/",
      "https://www.ecu.edu.au/schools/engineering/staff/profiles/associate-professors/associate-professor-sanjay-kumar-shukla",
      "http://tgsitharam.com",
      "https://iittp.ac.in/dr-a-murali-krishna",
      "https://www.iitdh.ac.in/user-profile/amarnath-hegde",
      "https://www.iitg.ac.in/arindam.dey/homepage/index.html",
      "https://www.linkedin.com/in/dr-cr-parthasarathy-1298896",
      "https://www.linkedin.com/in/venkata-uday-kala-%E0%A4%95%E0%A4%B2%E0%A4%BE-%E0%B0%95%E0%B3%B3-09417315",
      "https://civil.iisc.ac.in/people/madhavi-latha-g/",
      "https://www.linkedin.com/in/mahendra-singh-725a5a64",
      "https://www.linkedin.com/in/prof-dr-sunita-kumari-9324641a7",
      "https://www.iitbhu.ac.in/dept/civ/people/ankitciv",
      "https://igs.org.in/member/prof-bashir-ahmed-mir",
      "https://iith.ac.in/ce/basha/",
      "https://www.iitbhu.ac.in/dept/civ/people/kumarbrindciv",
      "https://www.civil.iitb.ac.in/faculty/details/prof-deepankar-choudhury-fnae-fnasc-fasc-f-asce",
      "https://www.civil.iitb.ac.in/faculty/details/prof-dharamveer-singh",
      "https://civil.iisc.ac.in/~gls/",
      "https://sites.google.com/view/jagdish-prasad-sahoo",
      "https://home.iitk.ac.in/~madhav/",
      "https://scholar.google.com/citations?user=BwZb9e0AAAAJ&hl=en",
      "https://www.igs.org.in/member/dr-d-neelima-satyam",
      "https://systems.enpress-publisher.com/index.php/TM/about/editorialTeamBio/14595",
      "https://www.civil.iisc.ac.in/people/anbazhagan-p/",
      "https://www.linkedin.com/in/ravi-sundaram-78745b15",
      "https://scholar.google.com/citations?user=7vJ-aqoAAAAJ&hl=en",
      "https://civil.iitm.ac.in/faculty/vbmaji/",
      "https://www.iitp.ac.in/~tns/profile.html",
      "https://www.linkedin.com/in/niranjan-singh-6b5ba023",
    ][i]
  } `,
  designation: `${
    [
      "Assistant Professor & Head",
      "Professor",
      "Associate Professor",
      "Professor",
      "Director & Professor",
      "Associate Professor",
      "",
      "Chair, ISSMGE TC202 Transportation Geotechnics",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Associate Professor",
      "Director",
      "Professor",
      "Professor",
      "Professor",
      "Professor & Head",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Retd. Professor",
      "Associate Professor",
      "Emeritus Professor",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Director",
      "Professor",
      "Professor",
      "Director",
      "Chairman",
    ][i]
  }`,
  organization: `${
    [
      "BITS Pilani, UAE Campus",
      "University of Bengkulu, Indonesia ",
      "University of Al-Qadisiyah Al- Qadisiyah, Iraq",
      "University of Illinois Chicago (UIC), USA",
      "Southern Illinois University, Carbondale, USA",
      "University of Technology Sydney, Australia",
      "National University of Sciences & Technology, West Indies",
      "Hokkaido University, Japan",
      "Edith Cowan University, Perth, Australia",
      "Indian Institute of Science, Bengaluru",
      "Indian Institute of Technology, Tirupati",
      "Indian Institute of Technology, Dharwad",
      "Indian Institute of Technology, Guwahati",
      "Sarathy Lab Pvt. Ltd., Bengaluru ",
      "Indian Institute of Technology, Mandi ",
      "Indian Institute of Science, Bangalore ",
      "Indian Institute of Technology, Roorkee",
      "National Institute of Technology, Patna ",
      "Indian Institute of Technology (BHU) Varanasi ",
      "National Institute of Technology, Srinagar",
      "Indian Institute of Technology, Hyderabad",
      "Indian Institute of Technology (BHU) Varanasi",
      "Indian Institute of Technology, Bombay ",
      "Indian Institute of Technology, Bombay",
      "Indian Institute of Science, Bengaluru",
      "Indian Institute of Technology Kanpur",
      "Indian Institute of Technology, Hyderabad",
      "Indian Institute of Technology, Roorkee",
      "Indian Institute of Technology, Indore",
      "Maulana Azad National Institute of Technology, Bhopal",
      "Indian Institute of Science, Bengaluru",
      "Cengrs Geotechnica Pvt. Ltd., Noida",
      "Aligarh Muslim University, Aligarh",
      "Indian Institute of Technology, Madras",
      "Indian Institute of Technology, Patna ",
      "Arun Soil Lab, Lucknow",
    ][i]
  }`,
  image: `/images/committee/advisory/member${i + 1}.jpg`,
}));

export const technicalCommittee = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Dr. R. P. Singh",
      "Dr. Arif Ali Baig Moghal",
      "Dr. Sreevalsa Kolathayar",
      "Dr. Gottumukkala Bharath",
      "Dr. Baadiga Ramu",
      "Dr. Ankesh Kumar",
      "Dr. Avinash Kumar Singh",
      "Dr. Vijay Kumar",
      "Dr. Aditya Kumar Das",
      "Mr. Shashank Bhatnagar",
      " Dr. Pawan Kumar Chamling",
      "Dr. Amit Srivastava",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.linkedin.com/in/dr-raghvendra-pratap-singh-4413a313",
      "https://erp.nitw.ac.in/ext/profile/ce-baig",
      "https://civil.nitk.ac.in/professor/sreevalsa-kolathayar",
      "https://www.linkedin.com/in/dr-bharath-gottumukkala-0b124a9b",
      "https://sites.google.com/view/ramubaadiga",
      "https://iitpkd.ac.in/people/ankesh",
      "https://people.iitism.ac.in/~download/cv/1418/1418.pdf",
      "https://mnnit.ac.in/profile/previewr.php?id=1797",
      "https://www.nitrkl.ac.in/FacultyStaff/FacultyProfile/?id=dasaditya",
      "https://in.linkedin.com/in/shashank-bhatnagar-459331192",
      "https://www.linkedin.com/in/pawan-kumar-chamling-21781865?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/dr-amit-srivastava-770b15147/",
    ][i]
  } `,
  designation: `${
    [
      "Joint General Manager",
      "Professor",
      "Associate Professor",
      "Principal Scientist",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Scientist",
      "Assistant Professor",
      "Professor",
    ][i]
  }`,
  organization: `${["NHSRCL", "CED, NIT Warangal", "NIT Karnataka, Surathkal", "CSIR CRRI, New Delhi", "Civil Department, IIT Indore", "CED, IIT Palakkad", "CED, IIT(ISM) Dhanbad", "CED, MNNIT Allahabad", "CED, NIT Rourkela", "CSIR CBRI, Roorkee", "NIT Andhra Pradesh", "CED, Graphic Era (Deemed to be) University, Dehradun"][i]}`,
  image: `/images/committee/technical/member${i + 1}.jpg`,
}));

//website committee
export const websiteCommittee = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Prof. Mohammad Faisal",
      "Dr. Vikash Singh",
      "Mr. Abdullah Aqeel",
      "Mr. Mohd. Tanveer",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Computer%20Application/_Computer%20Application-Dr%20Mohammad%20Faisal_ShortCV.pdf",
      "https://linkedin.com/in/vikash-singh-6292b3334",
      "https://www.linkedin.com/in/abdullah-aqeel-b4080228a",
      "",
    ][i]
  } `,
  designation: ` ${["Provost & Head", "Assistant Professor & Treasurer", "Lab Instructor", "Office Assistant"][i]}`,
  organization: `${["CA Dept., Integral University", "CED, IET and IGS Lucknow Chapter", "CA Dept, Integral University", "CED, Integral University"][i % 4]}`,
  image: `/images/committee/website/member${i + 1}.jpg`,
}));

//programme committee
export const programmeCommittee = Array.from({ length: 30 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Dr. Neha Mumtaz",
      "Dr. Yusuf Jamal",
      "Mr. Mohd. Kashif Khan",
      "Dr. Tabish Izhar",
      "Dr. Mohd Sadat",
      "Mr. Mohd Asim",
      "Mr. Faraz Hasan Qadri",
      "Dr. Ahmad Rashiq",
      "Mr. Mohd Yaqoob",
      "Sumit Kumar Chaudhary",
      "Mr. Rajat Verma",
      "Mr. Mohammad Riyaz",
      "D. K. Singh",
      "Usman Ali",
      "Amresh Yadav",
      "Hamza Imran",
      "Maaz Arshad",
      "Nabeel Ahmad",
      "Ruban Khan",
      "Arshad Hameed",
      "Manubolu Monica Sree",
      "Prakhar Tyagi",
      "Ujjawal Srivastava",
      "Manoo Singh",
      "Shahbaz Ahmad Mir",
      "Ahmad Hamza Kazmain",
      "Jamia Hassan",
      "Mohammad Danish",
      "Aaqil Ahmad",
      "Swastik Nigam",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Dr.%20Neha%20Mumtaz.pdf",
      "https://www.linkedin.com/in/yusuf-jamal-9142a8101/",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Mr.%20Mohd%20Kashif%20Khan.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Dr.%20Tabish%20Izhar.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Dr.%20Mohd%20Sadat.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Mr.%20Mohd%20Asim.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-CV_Faraz%20Hasan%20Qadri.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_F01402-134173341135131247CV%20Ahmad%20Rashiq.pdf",
      "https://www.iul.ac.in/CE/SupportingStaff.aspx",
      "https://www.iul.ac.in/CE/SupportingStaff.aspx",
      "https://www.iul.ac.in/CE/SupportingStaff.aspx",
      "https://www.iul.ac.in/CE/SupportingStaff.aspx",
      "https://www.linkedin.com/in/ahmad-hamza-kazmain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/ahmad-hamza-kazmain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/ahmad-hamza-kazmain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/hamza-imran-2468b0176?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/maaz-arshad-136b65336?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/nabeel-ahmad-846b38232",
      "https://www.linkedin.com/in/ruban-khan-0375802b2/?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/arshad-hameed-012644351?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/manubolu-monicasree-41829b241",
      "https://www.igs.org.in/local-chapter/lucknow",
      "https://www.igs.org.in/local-chapter/lucknow",
      "https://www.linkedin.com/in/manoo-singh-338667149?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/mirshahbazahmad",
      "https://www.linkedin.com/in/ahmad-hamza-kazmain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/jamia-hasan-1529b9277",
      "https://www.linkedin.com/in/mohammad-danish-9001b6286?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/aaqil-ahmad-0b04002a5?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/swastik-nigam-0b207b331?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    ][i]
  } `,
  designation: ` ${
    [
      "Associate Professor",
      "Associate Professor",
      "Associate Professor",
      "Associate Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Senior Lab Instructor",
      "Lab Instructor",
      "Lab Instructor",
      "Lab Instructor",
      "Research Scholar",
      "Research Scholar",
      "Research Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "B.Tech. Student",
      "B.Tech. Student",
      "B.Tech. Student",
      "B.Tech. Student",
      "B.Tech. Student",
    ][i]
  }`,
  organization: `${
    [
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
    ][i]
  }`,
  image: `/images/committee/programme/member${i + 1}.jpg`,
}));

// SPEAKERS WITH IMAGES (8 each)
export const keynoteSpeakers = Array.from({ length: 9 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Prof. Tatsuya Ishikawa",
      "Dr. Lindung Zalbuin Mase",
      "Dr. Praveen Kumar",
      "Dr. M. Amaranatha Reddy",
      "Dr. Neelima Satyam Devarakonda",
      "Dr. Arif Ali Baig Moghal",
      "Dr. Kanwar Singh",
      "Dr. Ramanathan Ayothiraman",
      "Dr. Ambika Behl",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.eng.hokudai.ac.jp/labo/geomech/english/member/",
      "https://engineering.unib.ac.id/bce/lecturers/",
      "https://civil.iitr.ac.in/CE?Uid=pkaerfce",
      "https://www.iitkgp.ac.in/department/CE/faculty/ce-manreddy",
      "https://people.iiti.ac.in/~neelima.satyam/",
      "https://www.linkedin.com/in/dr-arif-ali-baig-moghal-1b815449/",
      "https://www.linkedin.com/in/kanwar-singh-12a517aa/",
      "https://old.iittp.ac.in/prof-ramanathan-ayothiraman",
      "https://crridom.gov.in/en/node/543",
    ][i]
  } `,
  designation: `${["Professor & Chair", "Professor", "Professor", "Professor", "Professor", "Professor", "Chief Scientist & Head", "Professor", "Senior Principal Scientist"][i]}`,
  organization: `${["Hokkaido University, Japan & ISSMGE (Tc202)", "University of Bengkulu, Indonesia ", "IIT Roorkee", "IIT Kharagpur", "IIT Indore", "NIT Warangal", "CSIR-CRRI, New Delhi", "IIT Tirupati", "CSIR-CRRI, New Delhi"][i]}`,
  image: `/images/speakers/keynote/speaker${i + 1}.jpg`,
}));

export const invitedSpeakers = Array.from({ length: 2 }, (_, i) => ({
  id: i + 1,
  name: `${["Dr. R. P. Singh", "Dr. Sreevalsa Kolathayar"][i]}`,
  linkedin: ` ${["https://www.linkedin.com/in/nikhil-saboo-330ab856/", "https://www.linkedin.com/in/sreevalsa-kolathayar-36164826/", "", ""][i]} `,
  designation: `${["Joint General Manager (Civil)", "Associate Professor"][i]}`,
  organization: `${["National High Speed Rail Corporation Limited, Mumbai", "NIT Karnataka, Surathkal"][i]}`,
  image: `/images/speakers/invited/speaker${i + 1}.jpg`,
}));

export const sessionChairs = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: `${[][i]}`,
  linkedin: ` ${["", "", "", ""][i]} `,
  designation: "Session Chair",
  organization: `${[][i]}`,
  image: `/images/speakers/chairs/speaker${i + 1}.jpg`,
}));

// CALL FOR PAPERS WITH PDF AND GOOGLE FORM
export const callConfig = {
  abstract: {
    pdfUrl: "/pdfs/call/Abstract_temp.pdf",
    googleFormUrl: "https://forms.gle/jx72FZYdVw1x43eg6",
  },
  papers: {
    pdfUrl: "/pdfs/call/abstract.pdf",
    googleFormUrl: "https://forms.gle/your-papers-form-link",
  },
  oral: {
    pdfUrl: "/pdfs/call/abstract.pdf",
    googleFormUrl: "https://forms.gle/your-oral-form-link",
  },
  poster: {
    pdfUrl: "/pdfs/call/abstract.pdf",
    googleFormUrl: "https://forms.gle/your-poster-form-link",
  },
};

// SCHEDULE
export const schedule = [
  {
    date: "October 8, 2026",
    events: [
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
    ],
  },
  {
    date: "October 9, 2026",
    events: [
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
    ],
  },
  {
    date: "October 10, 2026",
    events: [
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
      { time: "To be declared", activity: "TBD" },
    ],
  },
];

export const bankingDetails = {
  accountNumber: "1854010100004840",
  holderName: "Integral University",
  bankName: "Punjab National Bank",
  branch: "Dasauli, Kursi Road, Lucknow",
  ifscCode: "PUNB0478600",
  MICRcode: "226024038",
  swiftCode: "PUNBINBBLHT",
};

export const registrationFormUrl = " https://tgsmart2026.iul.ac.in/Register/";

// SPONSORSHIP
export const sponsorshipTiers = [
  { id: 1, title: "Title Sponsor", amount: "₹3,50,000" },
  { id: 2, title: "Platinum Sponsor", amount: "₹2,50,000" },
  { id: 3, title: "Diamond Sponsor", amount: "₹1,75,000" },
  { id: 4, title: "Gold Sponsor", amount: "₹1,25,000" },
  { id: 5, title: "Silver Sponsor", amount: "75,000" },
  { id: 6, title: "Bronze Sponsor", amount: "50,000" },
  { id: 7, title: "Well Wisher", amount: "25,000" },
];

export const sponsorshipdetails = "/pdfs/call/sponsor.pdf";

export const sponsorTiers = [
  {
    name: "Diamond",
    files: [
      "sponsord1.jpeg",
      "sponsord3.jpeg",
      "sponsord4.jpeg",
      "sponsord5.jpeg",
    ],
  },
  {
    name: "Gold",
    files: [
      "sponsorg1.jpeg",
      "sponsorg2.jpeg",
      "sponsorg3.jpeg",
      "sponsorg4.jpeg",
      "sponsorg5.jpeg",
    ],
  },
  {
    name: "Silver",
    files: ["sponsors1.jpeg", "sponsors2.jpeg"],
  },
  {
    name: "Bronze",
    files: [
      "sponsorb1.jpeg",
      "sponsorb2.jpeg",
      "sponsorb3.jpeg",
      "sponsorb4.jpeg",
      "sponsorb5.jpeg",
    ],
  },
  {
    name: "Wellwisher",
    files: [
      "sponsorw1.jpeg",
      "sponsorw2.jpeg",
      "sponsorw3.jpeg",
      "sponsorw4.jpeg",
      "sponsorw5.jpeg",
      "sponsorw6.jpeg",
    ],
  },
];

// CONTACT INFO
export const contactInfo = {
  organization: "Integral University, Lucknow",
  address: "Kursi Road, Lucknow, Uttar Pradesh 226026, India",
  email: "tgsmart2026@iul.ac.in",
  phone: "+91-8707870833, +91-9415985237, +91-9026074042",
  website: "https://tgsmart2026.iul.ac.in",
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3556.2762350643666!2d80.99890839999999!3d26.9581503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bff2addd9b239%3A0xc21a9bbd557936ec!2sIntegral%20University!5e0!3m2!1sen!2sin!4v1776052817067!5m2!1sen!2sin",
};

// SOCIAL MEDIA LINKS
export const socialMediaLinks = {
  facebook: "https://facebook.com/tgsmart2026",
  twitter: "https://twitter.com/tgsmart2026",
  linkedin: "https://linkedin.com/company/tgsmart2026",
  instagram: "https://instagram.com/tgsmart2026",
  youtube: "https://youtube.com/@tgsmart2026",
};

// GALLERY
export const galleryImages = Array.from(
  { length: 10 },
  (_, i) => `/images/gallery/gallery${i + 1}.jpg`,
);

// ABOUT CONTENT
export const aboutContent = {
  aboutConference: {
    title: "TG-SMART CONFERENCE",
    text: "The International Conference on Transportation Geotechnics and Sustainable Materials for Advanced Resilient Infrastructure (TG-SMART 2026) aims to bring together academicians, researchers, industry professionals, and policymakers to deliberate on emerging challenges and innovations in transportation geotechnics and sustainable infrastructure. The conference will focus on ground improvement, geosynthetics, waste-to- resource materials, geo-hazards, computational geotechnics, and climate- resilient infrastructure. Through technical sessions, industry interactions, poster presentations, and keynote lectures by eminent experts. TG-SMART 2026 seeks to promote research-driven, practical, and sustainable solutions for future infrastructure development.",
    image: "/images/about/logo.jpg",
  },
  integralUniversity: {
    title: "INTEGRAL UNIVERSITY, LUCKNOW",
    text: "Integral University is a premier university in Lucknow, the capital city of the state of Uttar Pradesh, India. It was established under the Act Number 9 of 2004 by the State Government. The University is duly approved by the overnme University Grants Commission (UGC) undersections 2(f) and 12B of the UGC Act, 1956, Medical Council of India, Pharmacy Council of India, Indian Nursing Council, Council of Architecture, Bar Council of India, Indian Association of Physiotherapists, National Council for Teacher Education, UP State Medical Faculty and Distance Education Bureau. Integral University is accredited by NAAC(A+) and recognized as a Scientific &Industrial Research Organization (SIRO) & Public Funded Research Institution (PFRI) by the Department of Scientific & Industrial Research, Ministry of Science & Technology, Government of India.",
    image: "/images/about/integral-university.jpg",
  },
  lucknowChapter: {
    title: "IGS, LUCKNOW CHAPTER",
    text: "The IGS Lucknow Chapter is an active local chapter of the Indian Geotechnical Society, with professional and engineers from academia and industry collaborating to promote geotechnical engineering in the region. The chapter currently has 27 members and engages in knowledge-sharing activities and professional networking. It's the 56th chapter of Indian Geotechnical Society. Prof. Syed Aqeel Ahmad serves as the Chairman of this chapter. The IGS Lucknow Chapter provides a platform for members to participate in technical discussions and contribute to the broader geotechnical community.",
    image: "/images/about/lucknow-chapter.jpg",
  },
  csirCbri: {
    title: "CSIR-CENTRAL BUILDING RESEARCH INSTITUTE",
    text: "The Central Building Research Institute (CBRI), Roorkee, a constituent laboratory of CSIR, is India's premier national institute dedicated to building science and technology. Established in 1947, CBRI undertakes comprehensive R&D in building materials, foundations, structural safety, disaster mitigation, fire engineering, and energy-efficient housing. As a collaborator with academic institutions and industry alike, CBRI's inclusion through an MoU adds tremendous value bringing world-class research, sustainable construction technologies, and practical industry-ready solutions that align closely with modern civil engineering education and infrastructure development needs.",
    image: "/images/about/csir-cbri.jpg",
  },
  csirCrri: {
    title: "CSIR-CENTRAL ROAD RESEARCH INSTITUTE",
    text: "The CSIR-Central Road Research Institute (CRRI), New Delhi, a constituent laboratory of the Council of Scientific and Industrial Research (CSIR), is India's premier national institute dedicated to road and transportation research. Established in 1952, CRRI has played a pivotal role in advancing pavement engineering, traffic and transportation planning, geotechnics, bridge engineering, road safety, and sustainable infrastructure development. The institute actively supports national highway development through innovative technologies, performance-based materials, recycling of industrial wastes, and carbon-neutral construction practices. With strong linkages to academia, industry, and government agencies, CSIR-CRRI provides research-driven, field-implementable solutions aligned with modern transportation infrastructure needs.",
    image: "/images/about/csir-crri.jpg",
  },
  civilDept: {
    title: "CIVIL ENGINEERING DEPARTMENT, INTEGRAL UNIVERSITY",
    text: "The Department of Civil Engineering, Integral University, Lucknow, offers B.Tech., M.Tech., and Ph.D. programs with a strong focus on industry- aligned education and research. The Department runs an industry-led B.Tech. program in collaboration with L&T EduTech, supported by immersive learning, internships, and site exposure. It hosts a Centre of Excellence on Sustainable Building Materials with Ultra Tech Cement Ltd. and has MoUs with CSIR-CBRI, Roorkee. Equipped with advance NABL-accredited laboratories, the Department actively undertakes consultancy, testing, and research to support sustainable and resilient infrastructure development.",
    image: "/images/about/civil-dept.jpg",
  },
};

export const registrationFees = [
  {
    category: "Delegates from Industry/Govt. Organization",
    earlyBirdIGS: "₹7000",
    earlyBirdNonIGS: "₹8000",
    regularIGS: "₹8000",
    regularNonIGS: "₹9000",
    foreign: "$100",
  },
  {
    category: "Academician/Faculty Members/Scientist",
    earlyBirdIGS: "₹5000",
    earlyBirdNonIGS: "₹6000",
    regularIGS: "₹6000",
    regularNonIGS: "₹7000",
    foreign: "$100",
  },
  {
    category: "Research Scholar",
    earlyBirdIGS: "₹4000",
    earlyBirdNonIGS: "₹5000",
    regularIGS: "₹5000",
    regularNonIGS: "₹6000",
    foreign: "$80",
  },
  {
    category: "UG/PG Students",
    earlyBirdIGS: "₹3000",
    earlyBirdNonIGS: "₹3500",
    regularIGS: "₹3500",
    regularNonIGS: "₹4000",
    foreign: "$50",
  },
  {
    category: "Accompanying Person/Spouse",
    earlyBirdIGS: "₹2500",
    earlyBirdNonIGS: "₹2500",
    regularIGS: "₹3000",
    regularNonIGS: "₹3000",
    foreign: "$50",
  },
];

export const contactperson = [
  {
    id: 1,
    name: "Dr. Zishan Raza Khan",
    linkedin: "",
    designation: "Associate Professor",
    organization: "Integral University, Lucknow",
    phone: "+91-9450706026",
    image: "/images/contactperson/cop4.jpg",
  },
  {
    id: 2,
    name: "Dr. Vikash Singh",
    linkedin: "",
    designation: "Assistant Professor",
    organization: "IET, Lucknow",
    phone: "+91-8707870833",
    image: "/images/contactperson/cop1.jpg",
  },
  {
    id: 3,
    name: "Dr. Aayush Kumar",
    linkedin: "",
    designation: "Assistant Professor",
    organization: "KMC Language University, Lucknow",
    phone: "+91-9415985237",
    image: "/images/contactperson/cop2.jpg",
  },
  {
    id: 4,
    name: "Mr. Harshit Srivastava",
    linkedin: "",
    designation: "Technical Director",
    organization: "Arun Soil Lab, Lucknow",
    phone: "+91-9026074042",
    image: "/images/contactperson/cop3.jpg",
  },
];

export const accommodations = [
  {
    id: 1,
    name: "Park Inn by Radisson",
    address: "Sector 14, Vikas Nagar, Lucknow",
    website: "https://www.radissonhotels.com",
    websiteLabel: "www.radissonhotels.com",
    phone: "7317500241",
    deluxe: 4500,
    executive: 4500,
  },
  {
    id: 2,
    name: "Vijay Paradise",
    address: "Ring Road, Vikas Nagar, Lucknow 226022",
    website: "https://www.vijayparadise.in",
    websiteLabel: "www.vijayparadise.in",
    phone: "7318099205",
    deluxe: 3500,
    executive: 4200,
  },
  {
    id: 3,
    name: "Sapna Clarks Inn",
    address: "CP-3, Sector 11, Vikas Nagar, Ring Road, Lucknow",
    website: "https://www.theclarkshotels.com",
    websiteLabel: "www.theclarkshotels.com",
    phone: "7408415950",
    deluxe: 3500,
    executive: 4000,
  },
  {
    id: 4,
    name: "The Royal Legacy",
    address: "CP5/1A, Vikas Nagar, Lucknow",
    website: "https://www.theroyallegacy.in",
    websiteLabel: "www.theroyallegacy.in",
    phone: "8400006545",
    deluxe: 2500,
    executive: 3000,
  },
  {
    id: 5,
    name: "Hotel SS Grand",
    address: "Misripur Guramba, Kursi Road, Lucknow",
    website: "https://sites.google.com/view/ss-grand-lucknow/home",
    websiteLabel: "SS Grand Lucknow",
    phone: "9115202115",
    deluxe: 1500,
    executive: 1800,
  },
  {
    id: 6,
    name: "Hotel Aradhna Inn",
    address: "Basha Chauraha, Kursi Road, Lucknow",
    website: "http://hotelaradhnainn.com",
    websiteLabel: "hotelaradhnainn.com",
    phone: "9112500226",
    deluxe: 1600,
    executive: 2200,
  },
];
